
import type { IdentityV1 } from '@alpod-ai-writer/backend';
import { createContext } from 'react';

export interface SessionContext {
    identity: IdentityV1.OwnRecord;
    isLoggedIn: boolean;
}

export const SessionContext = createContext<SessionContext>({
    identity: undefined as unknown as IdentityV1.OwnRecord,
    isLoggedIn: false
});
